import { createAction, props } from '@ngrx/store';
import { Group } from '@shared/models/group';

export const selectAddCustomerParentGroup = createAction(
  '[Customers] Select Add Customer',
  props<{ group: Partial<Group> }>(),
);
